import React from "react";

const Prijmacky = () => {
  return (
    <div>
      <h1>Prijmacky</h1>
      <p>nevimmm</p>
    </div>
  );
};

export default Prijmacky;